/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PublicFilterNotificationRuleMonitorScopeConditionDto } from './PublicFilterNotificationRuleMonitorScopeConditionDto';

export type PublicMonitorTemplateFilterNotificationRuleMonitorScopeConditionDto = (PublicFilterNotificationRuleMonitorScopeConditionDto & {
    /**
     * List of the monitor templates in the condition
     */
    monitorTemplates?: Array<'COMPLETENESS' | 'ROW_LEVEL_DUPLICATES' | 'FRESHNESS' | 'SCHEMA_CHANGE' | 'FRESHNESS_UPDATE_TIME_GAP' | 'NUMERICAL_TRANSFORMATION' | 'CORRELATED_METRICS' | 'CUSTOM_METRICS' | 'DISTRIBUTION' | 'UNIQUE' | 'REFERENTIAL_INTEGRITY' | 'NOT_IN_LIST' | 'COUNT_DUPLICATE' | 'NULLS' | 'VALUE_RANGE' | 'IS_EMAIL' | 'IS_PHONE_NUMBER' | 'IS_UUID' | 'MATCHES_REGEX' | 'NO_CODE_CONDITION' | 'SQL_CONDITION' | 'SQL' | 'DBT'>;
    /**
     * Operator of the condition
     */
    operator?: PublicMonitorTemplateFilterNotificationRuleMonitorScopeConditionDto.operator;
} & {
    /**
     * List of the monitor templates in the condition
     */
    monitorTemplates: Array<'COMPLETENESS' | 'ROW_LEVEL_DUPLICATES' | 'FRESHNESS' | 'SCHEMA_CHANGE' | 'FRESHNESS_UPDATE_TIME_GAP' | 'NUMERICAL_TRANSFORMATION' | 'CORRELATED_METRICS' | 'CUSTOM_METRICS' | 'DISTRIBUTION' | 'UNIQUE' | 'REFERENTIAL_INTEGRITY' | 'NOT_IN_LIST' | 'COUNT_DUPLICATE' | 'NULLS' | 'VALUE_RANGE' | 'IS_EMAIL' | 'IS_PHONE_NUMBER' | 'IS_UUID' | 'MATCHES_REGEX' | 'NO_CODE_CONDITION' | 'SQL_CONDITION' | 'SQL' | 'DBT'>;
    /**
     * Operator of the condition
     */
    operator: PublicMonitorTemplateFilterNotificationRuleMonitorScopeConditionDto.operator;
});

export namespace PublicMonitorTemplateFilterNotificationRuleMonitorScopeConditionDto {

    /**
     * Operator of the condition
     */
    export enum operator {
        IS = 'IS',
        IS_NOT = 'IS_NOT',
    }


}
